import React from 'react';
import styles from './NavMenu.module.scss';
import { useLocation, useNavigate } from 'react-router-dom';
import WebApp from '@twa-dev/sdk';

import { ReactComponent as HomeIcon } from '@/assets/Icons/home.svg';
import { ReactComponent as TicketIcon } from '@/assets/Icons/ticket.svg';
import { ReactComponent as TrophyIcon } from '@/assets/Icons/trophy.svg';
import { ReactComponent as UserIcon } from '@/assets/Icons/users.svg';

import { useTelegram } from '@/app/providers/TelegramProvider';
import { useNavMenuStore } from '@/store/useNavMenuStore';
import { useNotificationStore } from '@/store/NotificationStore';

interface NavMenuProps {
  onRaffleOpen?: () => void;
}

const NavMenu: React.FC<NavMenuProps> = ({ onRaffleOpen }) => {
  const location = useLocation();
  const { isVisible } = useNavMenuStore();
  const navigate = useNavigate();
  const { systemInsets, contentInsets } = useTelegram();
  const { setNotification } = useNotificationStore.getState();

  const isTabActive = (path: string) => location.pathname === path;
  const isTabBlocked = (path: string) => false;

  const textTopath = (path: string) => {
    switch (path) {
      case '/':
        return 'Главная';
      case '/friends':
        return 'Друзья';
      case '/leaderboard':
        return 'Лидеры';
      case '/raffles':
        return 'Розыгрыши';
      default:
        return '';
    }
  };

  if (!isVisible) return null;

  const handleTabClick = (path: string) => (e: React.MouseEvent) => {
    if (WebApp?.HapticFeedback) {
      WebApp.HapticFeedback.impactOccurred('medium');
    }

    if (path === '/raffles' && onRaffleOpen) {
      onRaffleOpen();
      return;
    }

    if (isTabBlocked(path)) {
      setNotification({
        type: 'Warning',
        message: `Раздел "${textTopath(path)}" скоро будет доступен.`,
      });
      e.preventDefault();
      return;
    }

    navigate(path);
  };

  return (
    <>
      {location.pathname === '/leaderboard' && (
        <div className={styles.navMenuWrapper}>
          <div
            style={{
              height: `${systemInsets.bottom * 2 + 53}px`,
            }}
            className={styles.navMenuLeaderboardBackground}
          />
        </div>
      )}

      <div
        className={styles.navMenu}
        style={{
          bottom: `${systemInsets.bottom}px`,
        }}
      >
        <div className={styles.navMenu__content}>
          <button
            className={`${styles.navMenu__item} ${isTabActive('/') ? styles['navMenu__item--active'] : ''} ${
              isTabBlocked('/') ? styles['navMenu__item--blocked'] : ''
            }`}
            onClick={handleTabClick('/')}
          >
            <HomeIcon className={styles.navMenu__icon} />
            <span className={styles.navMenu__text}>Главная</span>
          </button>
          <button
            className={`${styles.navMenu__item} ${isTabActive('/friends') ? styles['navMenu__item--active'] : ''} ${
              isTabBlocked('/friends') ? styles['navMenu__item--blocked'] : ''
            }`}
            onClick={handleTabClick('/friends')}
          >
            <UserIcon className={styles.navMenu__icon} />
            <span className={styles.navMenu__text}>Друзья</span>
          </button>
          <button
            className={`${styles.navMenu__item} ${isTabActive('/leaderboard') ? styles['navMenu__item--active'] : ''} ${
              isTabBlocked('/leaderboard')
                ? styles['navMenu__item--blocked']
                : ''
            }`}
            onClick={handleTabClick('/leaderboard')}
          >
            <TrophyIcon className={styles.navMenu__icon} />
            <span className={styles.navMenu__text}>Лидеры</span>
          </button>
          <button
            className={`${styles.navMenu__item} ${isTabActive('/raffles') ? styles['navMenu__item--active'] : ''}`}
            onClick={handleTabClick('/raffles')}
          >
            <TicketIcon className={styles.navMenu__icon} />
            <span className={styles.navMenu__text}>Розыгрыши</span>
          </button>
        </div>
      </div>
    </>
  );
};

export default NavMenu;
